import Formsy from 'formsy-react'
import { createStructuredSelector } from 'reselect'

import FormsyInput from '@components/Textfield/withFormsy'
import Button from '@components/Button'
import Modal from '@components/Modal'
import ErrorMessage from '@components/ErrorMessage'

import useRequestPending from 'shared/hooks/useRequestPending'
import { useConfirm } from 'shared/hooks/useConfirm'

import { withTranslate } from '@i18n/utils'
import { savePadData } from 'dashboard-subscriptions/actions'
import { savePadPendingSelector } from 'dashboard-subscriptions/selectors'
import { SAVE_PAD_DATA_PROGRESS } from 'dashboard-subscriptions/constants'

import styles from './styles.module.scss'

const PadModal = ({ translate: t, onClose, savePadData, pending }) => {
    const { isLoading, error } = useRequestPending(pending, () => onClose(), SAVE_PAD_DATA_PROGRESS)
    const { confirm, ConfirmModal } = useConfirm()

    const onSubmit = async data => {
        const isConfirmed = await confirm()
        if (isConfirmed) {
            savePadData(data)
        }
    }

    const closeModal = () => {
        // This modal can have additional modals open.
        // This modal is second one opened after main subscription modal
        // Outside click handles all child modals as outside as well (due to React.Portal)
        // This checks if there are more modal open. If there is, onClose is ignored.
        // Only additional modals open, can be child modals.
        const modals = document.getElementsByClassName('modal-dropdown')
        if (modals.length === 2) {
            onClose()
        }
    }

    return (
        <>
            <ConfirmModal
                title="dashboard.subscriptions.pad.warning.title"
                text="dashboard.subscriptions.pad.warning"
            />
            <Modal className={styles.padModal} header={t('dashboard.subscriptions.pad.title')} onClose={closeModal}>
                <Formsy onSubmit={onSubmit}>
                    <FormsyInput
                        name="nameOnCard"
                        placeholder={t('dashboard.subscriptions.pad.name')}
                        validationError={t('dashboard.subscriptions.pad.name.invalid')}
                        required
                    />
                    <FormsyInput
                        name="achBankName"
                        placeholder={t('dashboard.subscriptions.pad.bank')}
                        validationError={t('dashboard.subscriptions.pad.bank.invalid')}
                        required
                    />
                    <FormsyInput
                        name="achAbaCode"
                        required
                        placeholder={t('dashboard.subscriptions.pad.bank.transit')}
                        validationError={t('dashboard.subscriptions.pad.bank.transit.invalid')}
                        pattern="^[\d]{5}$"
                        validations={{ matchRegexp: /^[\d]{5}$/ }}
                    />
                    <FormsyInput
                        name="achInsitutionId"
                        required
                        pattern="^[\d]{3}$"
                        validations={{ matchRegexp: /^[\d]{3}$/ }}
                        placeholder={t('dashboard.subscriptions.pad.bank.institution')}
                        validationError={t('dashboard.subscriptions.pad.bank.institution.invalid')}
                    />
                    <FormsyInput
                        name="achAccountNumber"
                        required
                        pattern="^[\d]+$"
                        validations={{ matchRegexp: /^[\d]+$/ }}
                        placeholder={t('dashboard.subscriptions.pad.bank.account')}
                        validationError={t('dashboard.subscriptions.pad.bank.account.invalid')}
                    />
                    {error && <ErrorMessage messages={[error]} />}
                    <div className="d-sm-flex mt-2">
                        <Button disabled={isLoading} btnStyle="outline" className="w-50" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button disabled={isLoading} isLoading={isLoading} btnStyle="primary" className="w-50">
                            Submit
                        </Button>
                    </div>
                </Formsy>
            </Modal>
        </>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            pending: savePadPendingSelector,
        }),
        {
            savePadData,
        }
    )
)(PadModal)
